<section class="bg-white dark:bg-gray-900">
  <div class="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 lg:px-12">
    <h1 class="mb-4 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">Reasons Why </h1>
    <div class="mb-8 text-lg font-normal text-gray-500 lg:text-xl sm:px-16 xl:px-48 dark:text-gray-400">
      <p>Manchmal reichen Worte nicht aus, um zu sagen, wie sehr wir jemanden schätzen. <strong>"Reasons Why"</strong> ist deine Möglichkeit, einer geliebten Person zu zeigen, wie einzigartig und wertvoll sie für dich ist – auf eine Weise, die von Herzen kommt.</p>
      <br>
      <h2>🌟 Warum „Reasons Why“?</h2>
      <p>Manchmal vergessen wir, wie viel die kleinen Dinge bedeuten:</p>
      <ul>
        <li>Ein Lächeln, das deinen Tag rettet.</li>
        <li>Die Wärme, die du spürst, wenn ihr Zeit zusammen verbringt.</li>
        <li>Die unausgesprochenen Gründe, warum du sie einfach liebst.</li>
      </ul>
      <br>
      <p>Unsere Plattform hilft dir dabei, all diese Gründe zu sammeln und kreativ zu präsentieren. Überrasche deine Herzensperson mit einer Botschaft, die sie nie vergessen wird – weil sie spürt, wie sehr sie geschätzt wird.</p>
      <br>
      <h2>💌 So funktioniert’s:</h2>
      <ol>
        <li><strong>Teile deine Gründe:</strong> Schreib auf, warum sie für dich so besonders ist.</li>
        <li><strong>Gestalte es persönlich:</strong> Nutze unsere liebevollen Vorlagen, um deine Botschaft zu individualisieren.</li>
        <li><strong>Überrasche sie:</strong> Teile deine Liste digital oder als schönes Geschenk, das von Herzen kommt.</li>
      </ol>
      <br>
      <h2>❤️ Mach den Moment unvergesslich</h2>
      <p>Zeig, wie viel dir jemand bedeutet – mit Worten, die von Herzen kommen. Ganz gleich, ob es sich um einen Jahrestag, einen besonderen Anlass oder einfach einen „Ich dachte an dich“-Moment handelt: <strong>„Reasons Why“</strong> macht aus Worten echte Gefühle.</p>
      <br>
      <p><strong>📖 Lass uns gemeinsam eine Geschichte schreiben, die zählt: die Geschichte eurer besonderen Verbindung.</strong></p>
    </div>
  </div>
</section>
